
import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Tooltip, Icon } from "antd";
import SelectHotel from "./SelectHotel";
const karte = {
    height: 400,
    width: "100%"
};

@inject('store')
@observer
class App extends Component {

    componentWillUnmount() {
        this.props.store.allHotel.onChangeHotelId(1);
    }

    render() {
        const { selectedRowKeys, onShow } = this.props.store.selectHotel;
        const { data, hotel_id, onChangeHotelId } = this.props.store.allHotel;
        return (
            <div className="rooms">

                <div className="hotel_name">
                    <Tooltip title="点击切换酒店" placement="topLeft">
                        <span onClick={onShow.bind(this, hotel_id)}>
                            {(data.find(x => x.id == (hotel_id || 1)) || {})['name']}
                            <Icon type="swap" />
                        </span>
                    </Tooltip>
                </div>

                <div id="Proportion" style={karte} ></div>
                <SelectHotel {...this.props} promiseFn={onChangeHotelId} />
            </div >
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/BI/headquarters/Proportion.js